import { render, staticRenderFns } from "./SportEventInfoForm.vue?vue&type=template&id=6052ea8a&"
import script from "./SportEventInfoForm.vue?vue&type=script&lang=js&"
export * from "./SportEventInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports